/**
 * Text helpers for the Bullseye tab, kept out of the components so the copy
 * is unit-tested.
 */
import type { BullseyeList } from "@nu-assist/contracts";

const MONTH_DAY = new Intl.DateTimeFormat("en-US", { month: "short", day: "numeric" });

/** "Oct 5" in the viewer's time zone; `""` for a missing or unreadable date. */
export function monthDay(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : MONTH_DAY.format(d);
}

/**
 * A label from an email's local part, the rule the API uses for `run_by_name`
 * (`olivia.mcknight@…` → `Olivia Mcknight`): the settings row stores only the
 * saver's email, and `app_users` has no names.
 */
export function nameFromEmail(email: string | null | undefined): string {
  if (!email) return "";
  const local = (email.split("@", 1)[0] ?? "").split("+", 1)[0] ?? "";
  const words = local.split(/[._]+/).filter(Boolean);
  if (!words.length) return email;
  return words.map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(" ");
}

/** "AI Review · Oct 1 · 4 criteria" */
export function listSubtitle(list: BullseyeList): string {
  const n = list.criteria.length;
  return `AI Review · ${monthDay(list.applied_at)} · ${n} ${n === 1 ? "criterion" : "criteria"}`;
}

/** "Run by Olivia Mcknight", falling back to the email when it has no usable name. */
export function runBy(list: BullseyeList): string {
  return `Run by ${list.run_by_name ?? list.run_by_email}`;
}
